app = angular.module("seismology")

ref = firebase.database().ref()


app.factory "TranscriptionFactory", ($firebaseObject, $firebaseArray, $firebaseAuth, TextConverter, Users, History, Timeline, Books, $sce, $window, CurrentUser) ->

  STATES = {
    default:
      code: 'default'
      label: '未着手'
      desc: 'まだ翻刻されていません'
    initiated:
      code: 'initiated'
      label: '着手済み'
      desc: '一部の文字のみ翻刻が完了した状態です'
    finished:
      code: 'finished'
      label: '翻刻完了'
      desc: 'すべての文字の翻刻が完了した状態です。'
    editing_current:
      code: 'editing_current'
      label: 'あなたが編集中'
      desc: 'あなたが編集中のため，他ユーザーは変更できません'
    editing_others:
      code: 'editing_others'
      label: '他ユーザーが編集中'
      desc: '他のユーザーが編集中のため，変更できません'
    frozen:
      code: 'frozen'
      label: '保護中'
      desc: '管理メンバーを除き翻刻文を変更できません．'
  }
  
  
  $firebaseObject.$extend

    editingListRef: ->
      uid = $firebaseAuth().$getAuth().uid
      ref.child('users').child(uid).child("editing")

    getEditingRecord: ->
      bookId = @getBookId()
      content = @$id
      bookId_content = "#{bookId}_#{content}"
      uid = $firebaseAuth().$getAuth().uid
      $firebaseObject(ref.child('users').child(uid).child("editing").child(bookId_content))

    addToEditingRecord: ->
      record = @getEditingRecord()
      record.bookId = @getBookId()
      record.content = parseInt(@$id)
      record.timestamp = @timestamp
      record.$save().catch (err)->
        console.log err

    removeFromEditingRecord: ->
      @getEditingRecord().$remove()
      
    getBookId: ->
      @$ref().toString().split("/").reverse()[1]

    getCode: ->
      @getBookId()+ '-' + @$id
  
    startEditing: (realtimeMode = false) ->
      @prevStatus = @status
      @status = "editing"      
      @realtimeMode = realtimeMode
      @tempEditedBy = $firebaseAuth().$getAuth().uid
      @timestamp= firebase.database.ServerValue.TIMESTAMP
      @tempText = @text      
      @tempChanged = false
      @addToEditingRecord()
      @
      
    endEditing: ->
      @status = "initiated"
      @realtimeMode = false
      @timestamp= firebase.database.ServerValue.TIMESTAMP
      @editedBy = $firebaseAuth().$getAuth().uid
      @text = @tempText
      @tempChanged = false
      @removeFromEditingRecord()
      #@addHistory()      
      @

    abortEditing: ->
      @status = @prevStatus or "initiated"
      @realtimeMode = false
      @tempText = null
      @tempEditedBy = null
      @tempChanged = false
      @removeFromEditingRecord()
      @

    setTempChanged: (changed = true) ->
      @tempChanged = changed
      @

    setFinished: ->
      @status = 'finished'
      @
      
    freeze: ->
      @frozen = true
      @timestamp= firebase.database.ServerValue.TIMESTAMP
      @editedBy = $firebaseAuth().$getAuth().uid
      tempChanged = false
      @

    unfreeze: ->
      @frozen = false
      @timestamp= firebase.database.ServerValue.TIMESTAMP
      @editedBy = $firebaseAuth().$getAuth().uid
      tempChanged = false
      @
      

    isEditable: ->
      return true if CurrentUser.get().isAdmin()
      return false if @isFrozen()
      (@status is "default") or (@status is "initiated") or (@status is "finished")

    isEditingByCurrentUser: ->
      if @status is "editing"
        uid = $firebaseAuth().$getAuth().uid
        @tempEditedBy is uid
      else
        false

    isFrozen: ->
      @frozen

    getCurrentState: ->
      if @status is "editing"        
        if @isEditingByCurrentUser()
          STATES['editing_current']
        else
          STATES['editing_others']
      else
        STATES[@status]

    getFormattedHtml: ()->
      if @isEditingByCurrentUser() or @realtimeMode
        text = @tempText
      else
        text = @text
      return "" unless text
      html = TextConverter.convert(text)
      html

    addHistory: ->
      history = History.getList(@getBookId())
      console.log history
      history.$add
        event: 'transcription'
        uid: $firebaseAuth().$getAuth().uid
        timestamp: firebase.database.ServerValue.TIMESTAMP
        data: @

    getTrustedText: ->
      $sce.trustAsHtml(@text)

    getNoteArray: (bookId, index, size=20) ->
      notesRef = @$ref().child("notes").orderByChild("timestamp").limitToLast(size)
      $firebaseArray(notesRef)
    
    addNote: (text) ->
      uid = $firebaseAuth().$getAuth().uid
      timestamp= firebase.database.ServerValue.TIMESTAMP
      @getNoteArray().$add {uid: uid, timestamp: timestamp, text: text}
      
    countDiff: ->
      diff = $window.JsDiff.diffChars(@text.replace(/<br>/g,""), @tempText.replace(/<br>/g,""))
      count = 0
      console.log diff
      for d in diff
        count+= d.value.length if d.added
      count



      
app.factory "Diff", ($window) ->

  diffChars: (original, revised) ->
    $window.JsDiff.diffChars(original, revised)

  styledDiffHtml: (original, revised) ->
    diff = @diffChars(original, revised)
    html = ""
    for d in diff
      if d.added
        html += "<span class='diff added'>#{d.value}</span>"
      else if d.removed
        html += "<span class='diff removed'>#{d.value}</span>"
      else
        html += d.value
    html
    
app.factory "History", ($firebaseArray) ->

  historyRef = ref.child('history')

  getList: (bookId, limit=20)->
    $firebaseArray(historyRef.child(bookId).limitToLast(limit))

app.factory "TextConverter", ($sanitize)->

  # フォーマット：漢字（ルビ）
  ruby: (text)->
    text = text.replace(/\(/g,"（").replace(/\)/g,"）")
    text.replace /｜?\w?([一-龠々■？ゝゞヽヾ〻々〳〵〴〵]+?)（(.+?)）/g, (match, kanji, ruby) ->
      """
        <ruby>
          <rb>#{$sanitize(kanji)}</rb>
          <rt>#{$sanitize(ruby)}</rt>            
        </ruby>
        """

  rubyWildChar: (text) ->
    text.replace /《ルビ：(.+?)｜(.+?)》/g, (match, kanji, ruby) ->
      """
        <ruby>
          <rb>#{$sanitize(kanji)}</rb>
          <rt>#{$sanitize(ruby)}</rt>            
        </ruby>
      """
      
  # フォーマット：漢字（ルビ）
  warigaki: (text) ->
    text.replace /《割書：(.+?)｜(.+?)》/g, (match, right, left) ->
      """
        <span class="warigaki">
          <span class="warigaki-left">#{$sanitize(left)}</span>
          <span class="warigaki-right">#{$sanitize(right)}</span>            
        </span>
      """

  hako: (text) ->
    text.replace /《箱：((?:.|\n)+?)》/g, (match, content) ->
      console.log "hako", content
      "<span class='hako'>#{content}</span>"

  comment: (text) ->
    text.replace /【(.+?)】/g, (match, content) ->
      "<span class='comment'>（#{$sanitize(content)}）</span>"


  dubiousSingle: (text) ->
    text.replace /(.)？/g, (match, content) ->
      "<span class='dubious' >#{$sanitize(content)}</span>"

  dubiousMulti: (text) ->
    text.replace /《？：([\s\S]+?)》/g, (match, content) ->
      "<span class='dubious'>#{$sanitize(content)}</span>"

  illegible: (text) ->
    text.replace /(□+)/g, (match, content) ->
      "<span class='illegible'>#{content}</span>"

  kaeriten: (text) ->
    text.replace /｛(.+?)｝/g, (match, content) ->
      "<span class='kaeriten'>#{content}</span>"

  okuri: (text) ->
    text.replace /［(.+?)］/g, (match, content) ->
      "<span class='okuri'>#{content}</span>"

    
    
  convert: (text) ->
    conversions = ["illegible", "ruby", "rubyWildChar", "hako", "warigaki", "dubiousMulti", "dubiousSingle", "comment", "kaeriten", "okuri"]
    for c in conversions
      text = @[c].call(@, text)
    text


app.factory "TranscriptionList", ($firebaseArray, TranscriptionFactory) ->

  $firebaseArray.$extend
    $$added: (snap) ->      
      new TranscriptionFactory(snap.ref)
    $$updated: (snap)->
      @$getRecord(snap.key).$$updated(snap)


app.factory "Transcription", ($firebaseArray, TranscriptionFactory, TranscriptionList) ->  
  trscRef = ref.child('transcriptions')
  temporary = {}
  get: (bookId, contentId) ->    
    new TranscriptionFactory(trscRef.child(bookId).child(contentId))

  getList: (bookId)->
    new TranscriptionList(trscRef.child(bookId))

  saveTemp: (text)->



// WEBPACK FOOTER //
// ./app/services/transcription_services.coffee